import * as z from "zod/v4";

const GetReturnLogicSyncStatusInputSchema_ = z.object({ teamId: z.string() });

export const GetReturnLogicSyncStatusInputSchema: z.ZodType<GetReturnLogicSyncStatusInput> =
  GetReturnLogicSyncStatusInputSchema_;
export interface GetReturnLogicSyncStatusInput extends z.infer<
  typeof GetReturnLogicSyncStatusInputSchema_
> {}

const GetReturnLogicSyncStatusOutputSchema_ = z.object({
  configured: z.boolean(),
  // If configured, these fields are present
  syncInProgress: z.boolean().optional(),
  stopAt: z.string().optional(), // ISO date string
  current: z.string().optional(), // ISO date string
  lastForwardSyncAt: z.string().optional(), // ISO date string of the last completed forward sync
});

export const GetReturnLogicSyncStatusOutputSchema: z.ZodType<GetReturnLogicSyncStatusOutput> =
  GetReturnLogicSyncStatusOutputSchema_;
export interface GetReturnLogicSyncStatusOutput extends z.infer<
  typeof GetReturnLogicSyncStatusOutputSchema_
> {}

export const getReturnLogicSyncStatus = {
  name: "getReturnLogicSyncStatus" as const,
  input: GetReturnLogicSyncStatusInputSchema,
  output: GetReturnLogicSyncStatusOutputSchema,
};
